/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

/** Import exported objects from lower level directories */



/** Import exported objects from current directory files */

import { Appdiscovery } from './appDiscovery';
import { Driverinstall } from './driverInstall';
import { Driverupdaterecommendation } from './driverupdaterecommendation';
import { Kite } from './Kite';
import { Localgames } from './localgames';
import { Nvappinstall } from './nvappinstall';
import { Nvcpldisplayplugin } from './NvCplDisplayplugin';
import { Nvcplplugin } from './NvCplplugin';
import { Nvigoutil } from './nvigoutil';
import { Nvoc } from './NvOc';
import { Nvworkstation } from './NvWorkstation';
import { Overclockingnvc } from './OverClockingNvc';
import { Rise } from './Rise';

/** Import type definitions for all nested objects */

import { Types } from '../../types/index';

/** Import BridgeCommands type definition */

import { BridgeCommands } from '../../../src/bridge.commands';

/** Export current level object and nested objects */

export const Nvapp = {
Appdiscovery,
Driverinstall,
Driverupdaterecommendation,
Kite,
Localgames,
Nvappinstall,
Nvcpldisplayplugin,
Nvcplplugin,
Nvigoutil,
Nvoc,
Nvworkstation,
Overclockingnvc,
Rise
};



